<!-- TODO: Make an unit test to this component -->
<script lang="ts">
  import { PRICES_TO_NINJA_VEHICLE_TYPES, SERVICE_TYPES_NAMES } from '$lib/constants'
  import { capitalize, isAdapted, isLuxury } from '$lib/helpers'
  import { t } from '$lib/translations'
  import { CheckCircle, CheckCircle2 } from 'lucide-svelte'

  export let serviceType: string
  export let vehicleType: string

  const advantages: [string, string, string] = getServiceTypeAdvatages(serviceType)
  const conditions: string[] = getServiceTypeConditions(serviceType)

  function getServiceTypeConditions(serviceType: string): string[] {
    switch (capitalize(serviceType)) {
      case SERVICE_TYPES_NAMES.SHUTTLE:
        return [t.get('common.shuttle_condition_1'), t.get('common.shuttle_condition_2'), t.get('common.shuttle_condition_3')]
      case SERVICE_TYPES_NAMES.AT_DISPOSAL:
      case SERVICE_TYPES_NAMES.PRIVATE:
      case SERVICE_TYPES_NAMES.WHEELCHAIR:
        return [t.get('common.private_condition_1')]
      default:
        return []
    }
  }

  function getServiceTypeAdvatages(serviceType: string): [string, string, string] {
    switch (capitalize(serviceType)) {
      case SERVICE_TYPES_NAMES.SHUTTLE:
        return [t.get('common.shutlle_message'), t.get('common.shutlle_message2'), t.get('common.shutlle_message3')]
      case SERVICE_TYPES_NAMES.AT_DISPOSAL:
        return [t.get('common.atdisposal_message1'), t.get('common.atdisposal_message2'), t.get('common.atdisposal_message3')]
      case SERVICE_TYPES_NAMES.PRIVATE:
        return [t.get('common.private_message1'), t.get('common.private_message2'), t.get('common.private_message3')]
      case SERVICE_TYPES_NAMES.WHEELCHAIR:
        return [t.get('common.wheelchair_mesagge1'), t.get('common.wheelchair_mesagge2'), t.get('common.wheelchair_mesagge3')]
      default:
        return ['', '', '']
    }
  }

  function getImageByVehicleType(vehicleType: string) {
    switch (vehicleType) {
      case PRICES_TO_NINJA_VEHICLE_TYPES.BUS:
        return '/shuttle.png'
      case PRICES_TO_NINJA_VEHICLE_TYPES.ADAPTED_VEHICLE:
        return '/adapted.png'
      case PRICES_TO_NINJA_VEHICLE_TYPES.LUXURY_CAR:
      case PRICES_TO_NINJA_VEHICLE_TYPES.LUXURY_MINIVAN:
        return '/premier.png'
      case PRICES_TO_NINJA_VEHICLE_TYPES.CAR:
      case PRICES_TO_NINJA_VEHICLE_TYPES.MINIVAN:
        return '/private.png'
    }
  }
</script>

<div class="lg:grid lg:grid-cols-4 shadow-lg lg:h-[300px] lg:w-[80%] cursor-pointer lg:cursor-auto">
  <div class="hidden lg:col-span-1 lg:flex h-full items-center justify-center p-5">
    <img src={getImageByVehicleType(vehicleType)} alt={`Service image: ${serviceType}`} class="object-cover lg:first-letter:h-[150px]" />
  </div>

  <div id="service-details" class="bg-cs-orange lg:bg-white p-5 lg:col-span-2 lg:max-h-[300px]">
    <h1 class="text-white lg:text-cs-orange font-bold lg:text-3xl text-center lg:text-start uppercase flex flex-col lg:flex-row">
      <span>
        {#if isAdapted(vehicleType)}
          {$t('common.adapted_service')}
        {:else if isLuxury(vehicleType)}
          {$t('common.luxury_service')}
        {:else}
          {$t(`common.${serviceType.toLowerCase()}`)}
        {/if}
      </span>
    </h1>

    <ul class="mt-4 hidden lg:flex lg:flex-col">
      {#each advantages as advantage}
        <li class="flex flex-row items-center gap-2 text-base">
          <CheckCircle2 class="bg-green-600 rounded-full h-4 w-4 text-white" />
          {advantage}
        </li>
      {/each}
    </ul>
    <ul class="mt-4 hidden lg:flex lg:flex-col">
      <p>{$t('common.unavailable_for')}</p>
      {#each conditions as condition}
        <li class="flex flex-row items-center justify-start gap-2 text-base">
          <CheckCircle height={50} class="bg-orange-600 rounded-full h-4 w-4 text-white" />
          <p class="w-full max-w-5 mb-1">{condition}</p>
        </li>
      {/each}
    </ul>
  </div>
  <div class="flex justify-center items-center">
    <button class=" lg:flex uppercase bg-gray-500 hover:cursor-auto text-white lg:px-5 px-2 lg:py-3 py-3 lg:mt-3 mt-[45%]">
      <span class="lg:text-sm  text-xs font-semibold">{$t('common.unavailable')}</span>
    </button>
  </div>
</div>
